import type { JSX } from "react";
interface ButtonProps {
  onClick: () => void;
  imageSrc: string;
  title: string;
  altText: string;
}

export function PickerButton({ onClick, imageSrc, title, altText }: ButtonProps): JSX.Element {
  return (
    <button
      type="button"
      className="px-0 py-0 flex flex-row relative overflow-hidden rounded-xl cursor-pointer border-0 bg-scanner-accent w-full min-h-36.5 my-2.5 transition-shadow duration-150 ease-[cubic-bezier(0.2,0,0,1)] pointer-hover:hover:shadow-hover focus-visible:outline-2"
      tabIndex={0}
      onClick={onClick}
    >
      <img src={imageSrc} alt={altText} className="max-h-33 aspect-square object-cover rounded-lg m-2" />
      <div className="w-2/3 overflow-hidden justify-items-center self-center p-2 mr-2">
        <div className="text-base text-black items-center self-center text-left justify-self-start overflow-hidden">
          {title}
        </div>
      </div>
    </button>
  );
}
